import has from './has';
export default has;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/has-key.js
// module id = 78
// module chunks = 0